export default {"src":"/_next/static/media/backgroundOpenedDocEnVille50.145cfc0d.svg","height":167,"width":464,"blurWidth":0,"blurHeight":0};